import React__default from 'react';
import { Stack } from './Stack.js';

const EditorRows = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement(Stack, { gap: 0.5, direction: "column" }, children);
};

export { EditorRows };
//# sourceMappingURL=EditorRows.js.map
